import { GraphApprovalStatus } from "@custom-types/graphs"
import ApproveDenyGraphRunForm, {
  ApproveDenyGraphRunFormValues,
} from "@features/administration/approvals/ApproveDenyGraphRun/ApproveDenyGraphRunForm"
import RunGroupTable from "@features/scenarioDesign/RunGroupTable"
import { CircularProgress, Grid } from "@mui/material"
import { useGetApprovalQuery, usePatchApprovalMutation } from "@store/services/approvalsService"
import { useGetRunGroupByKeyQuery } from "@store/services/runService"
import logger from "@utils/logger"
import { useNavigate, useParams } from "react-router"

const ApproveDenyGraphRunPage = () => {
  const navigate = useNavigate()
  const urlParams = useParams()
  const approvalKey = urlParams.approvalKey!

  const { data: approval, isLoading: isApprovalLoading } = useGetApprovalQuery(approvalKey)
  const runGroupKey = approval?.run_group_key

  const { data: runGroup, isLoading: isRunGroupLoading } = useGetRunGroupByKeyQuery(
    runGroupKey ?? "",
    { skip: !runGroupKey },
  )

  const [patchApprovalMutation, { isLoading: isLoadingPatchApproval }] = usePatchApprovalMutation()

  const isLoading = isApprovalLoading || isRunGroupLoading

  const handleSubmit = async (
    values: ApproveDenyGraphRunFormValues,
    status: GraphApprovalStatus,
  ) => {
    if (!approval || isLoadingPatchApproval) return

    try {
      await patchApprovalMutation({
        key: approval.key,
        payload: {
          comments: values.comment ?? "",
          approval_status: status,
          creator_email: approval.creator_email,
        },
      })
      navigate("/Administration/Publish-Approvals")
    } catch (e) {
      logger.error("error during patching of approval", e)
    }
  }

  return (
    <Grid container direction="column" gap={3}>
      {isLoading && (
        <Grid item alignSelf="center">
          <CircularProgress />
        </Grid>
      )}
      <Grid item>
        <RunGroupTable
          sessionStorageName="approve-deny-graph-run-group-table"
          runGroups={runGroup ? [runGroup] : []}
        />
      </Grid>
      <Grid container justifyContent="center">
        <Grid item xs={8}>
          {approval && <ApproveDenyGraphRunForm approval={approval} onSubmit={handleSubmit} />}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default ApproveDenyGraphRunPage
